export default "__VITE_ASSET__D3L2ROdd__"